'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TIME_FORMATS = [{ key: 'time_format_1', value: '12', description: '12 hour clock' }, { key: 'time_format_2', value: '24', description: '24 hour clock' }];

var DEFAULT = exports.DEFAULT = TIME_FORMATS[0];
exports.default = TIME_FORMATS;


//////////////////
// WEBPACK FOOTER
// ./src/constants/timeFormats.js
// module id = 663
// module chunks = 0